import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import InnerWrapStore from '@src/pages/inner-wrap/store';
import { computed, observable } from 'mobx';
import { getOmniData } from '@src/services/omni-api';

let musicRef = null;
let timer = null;
class AuditionAudioStore extends BaseStore {
  innerWrapStore = new InnerWrapStore({
    title: '视听中心',
    current: 5,
    breadcrumb: [
      {
        title: '视听中心',
        link: '/?currentPage=5'
      },
      {
        title: '音乐',
        link: ''
      }
    ]
  });

  // @observable duration = 0;
  @observable musicList = [];
  @observable pageSize = 6;
  @observable current = 0; // swiper当前索引
  @observable currentMusicIndex = 0; // 当前播放音乐下标

  @observable isPlaying = false; // 是否播放
  @observable currentDuration = 0;
  @observable audioRef = null;
  @computed
  get currentMusic() {
    return this.musicList[this.currentMusicIndex];
  }
  @computed
  get currentIndex() {
    return this.currentMusicIndex;
  }

  @computed
  get duration() {
    return this.formatTimeToDuration(this.currentMusic?.duration || '00:00');
  }

  // 选择播放的音乐，包括上一首下一首的逻辑
  selectMusic = index => {
    if (index === 'prev') {
      if (this.currentMusicIndex === 0) {
        if (this.current === 0) {
          this.current = Math.ceil(this.musicList.length / this.pageSize) - 1;
        } else {
          this.current--;
        }
        // 当前页的条数
        const currentPageItemCount = Math.min(this.pageSize, this.musicList.length - this.current * this.pageSize);
        this.currentMusicIndex = currentPageItemCount - 1;
      } else {
        this.currentMusicIndex--;
      }
    } else if (index === 'next') {
      // 当前页的条数
      const currentPageItemCount = Math.min(this.pageSize, this.musicList.length - this.current * this.pageSize);
      if (this.currentMusicIndex === currentPageItemCount - 1) {
        if (this.current === Math.ceil(this.musicList.length / this.pageSize) - 1) {
          this.current = 0;
          this.currentMusicIndex = 0;
        } else {
          this.current++;
          this.currentMusicIndex = 0;
        }
      } else {
        this.currentMusicIndex++;
      }
    } else {
      this.currentMusicIndex = index;
      this.isPlaying = true;
    }
    // 统一调用
    this.setCurrentTime(0);
    // this.getAudioDuration();
  };
  /**
   * 设置当前播放页
   * @param {*} index 索引
   */
  setCurrent(index) {
    const maxIndex = Math.ceil(this.musicList.length / this.pageSize) - 1;
    if (index === 'prev') {
      if (this.current === 0) {
        this.current = maxIndex;
      } else {
        this.current--;
      }
    } else if (index === 'next') {
      if (this.current === maxIndex) {
        this.current = 0;
      } else {
        this.current++;
      }
    } else {
      if (index === this.current) {
        return;
      }
      this.current = index;
    }
    // this.currentMusicIndex = 0;
    // this.getAudioDuration();
    // this.setCurrentTime(0);
  }
  // 分钟时间格式转化为秒数
  formatTimeToDuration(time) {
    const [min, sec] = time.split(':').map(Number);
    return min * 60 + sec;
  }

  // 秒数转为 时间格式
  formatDuration(duration) {
    const min = Math.floor(duration / 60)
      .toString()
      .padStart(2, '0');
    let sec = (duration % 60).toString().padStart(2, '0');
    // sec向下取整,保证显示两位数
    sec = Math.floor(sec)
      .toString()
      .padStart(2, '0');
    return `${min}:${sec}`;
  }

  /**
   * 设置当前时间
   * @param {*} value 时间值
   */
  setCurrentTime = value => {
    // console.log(value);
    // 判断音乐是否在播放,在播放则暂停
    if (!this.audioRef.paused) {
      this.audioRef.pause();
    }
    this.currentDuration = value;
    this.audioRef.currentTime = value;
    // 节流，防止多次执行
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      // 设置播放器的当前时间
      this.audioRef.currentTime = value;
      // 如果之前是播放状态,则继续播放
      if (this.isPlaying) {
        this.playAudio(true);
      }
      clearTimeout(timer);
      timer = null;
    }, 200);
  };

  /**
   * 播放/暂停音乐
   * @param {*} isPlay
   */
  playAudio = isPlay => {
    this.isPlaying = isPlay;
    if (this.isPlaying) {
      this.audioRef.play();
      // 播放时监听播放进度
      this.audioRef.addEventListener('timeupdate', () => {
        this.currentDuration = this.audioRef?.currentTime;
      });
    } else {
      this.audioRef.pause();
    }
  };

  getData = async () => {
    try {
      const res = await getOmniData('channel_cat_1beee26b', [
        {
          dataSourceId: 'ds_cat_5665b05c' || '',
          page: 1,
          perPage: 99
        }
      ]);
      const data = res.ds_cat_5665b05c?.result?.items || [];
      const musicList = [];
      data.forEach((item, index) => {
        musicList.push({
          id: index + 1,
          title: item.title || '',
          singer: item.author || '',
          url: item.music?.[0]?.url || '',
          duration: item.song_dur || '-'
        });
      });
      this.musicList = musicList;
      this.getAudioDuration();
    } catch (error) {
      console.log(error);
    }
  };

  getAudioDuration = () => {
    return new Promise((resolve, reject) => {
      // 创建音频对象
      const audio = new Audio();

      // 设置音频源
      audio.src = this.currentMusic.url;

      // 当元数据加载完成时（包括时长信息）
      audio.addEventListener('loadedmetadata', () => {
        // 返回时长（秒）
        // this.duration = audio.duration;
        resolve(audio.duration);
      });

      // 处理加载错误
      audio.addEventListener('error', function() {
        reject(new Error('无法加载音频文件'));
      });

      // 开始加载音频
      audio.load();
    });
  };

  use() {
    super.use();
    useMount(async () => {
      this.getData();
      if (this.audioRef) {
        this.audioRef.addEventListener('ended', () => {
          // 播放结束,重置当前时间
          this.currentDuration = 0;
          // 切换下一首歌
          this.currentMusicIndex++;
          const maxIndex = Math.ceil(this.musicList.length / this.pageSize) - 1;
          if (
            this.currentMusicIndex >= this.pageSize ||
            this.currentMusicIndex >= this.musicList.length ||
            (this.current === maxIndex && this.currentMusicIndex >= this.musicList.length % this.pageSize)
          ) {
            this.currentMusicIndex = 0;
            this.setCurrent('next');
          }
          this.playAudio(true);
        });
      }
    });
  }
}

export default AuditionAudioStore;
